/**
 * Parse document cookies into an object.
 *
 * @return {Object} Object with cookie names as keys and values as values.
 */
export function getCookies() {
	const pairs = document.cookie.split(';');
	const cookies = {};
	for (let i = 0; i < pairs.length; i++) {
		const pair = pairs[i].split('=');
		cookies[pair[0].trim()] = decodeURIComponent(pair.slice(1).join('='));
	}
	return cookies;
}

/**
 * Get current post ID from page when not provided by gatedContent (e.g. body class postid-123).
 *
 * @return {number|false} Post ID or false.
 */
function getPostIdFromPage() {
	if (!document.body || !document.body.className) {
		return false;
	}
	const match = document.body.className.match(/\bpostid-(\d+)\b/);
	return match ? parseInt(match[1], 10) : false;
}

/**
 * Handle auto-download of resources after form submission.
 */
export async function handleAutoDownload() {
	// Check for auto_download query parameter.
	const urlParams = new URLSearchParams(window.location.search);
	const autoDownload = urlParams.get('auto_download');

	if (autoDownload !== '1' || !window.gatedContent) {
		return;
	}

	const postID = window.gatedContent.postID || getPostIdFromPage();
	if (!postID) {
		console.warn('Gated content auto-download: post ID not available. Ensure the resource script is loaded on this page.');
		return;
	}

	try {
		// Request download URL from server (validates access).
		const formData = new FormData();
		formData.append('action', 'get_resource_download_url');
		formData.append('postID', postID);
		formData.append('nonce', window.gatedContent.nonce);

		const response = await fetch(window.gatedContent.ajax, {
			method: 'POST',
			body: formData,
		});

		const data = await response.json();

		if (data.success && data.data && data.data.url) {
			// Create a temporary link element to trigger download.
			const link = document.createElement('a');
			link.href = data.data.url;
			link.download = data.data.name || 'download';
			link.style.display = 'none';
			document.body.appendChild(link);
			link.click();
			document.body.removeChild(link);
		} else {
			console.error('Failed to get download URL:', data.data?.message || 'Unknown error');
		}

		// Remove query parameter from URL without page reload.
		const newUrl = new URL(window.location);
		newUrl.searchParams.delete('auto_download');
		window.history.replaceState({}, '', newUrl.toString());
	} catch (error) {
		console.error('Error requesting download URL:', error);
	}
}
